export default __webpack_public_path__ + "static/media/icon-blank.cec7fc14.svg";